import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getrequisition } from '../redux/requisition';
import { CROP_PRODUCT_OPTIONS_WITH_RICE } from '../constants/cropProducts';
import Progress from '../components/Loader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  height: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const dt = new Date();
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [farmer, setfarmer] = React.useState("none");
  const [agent_, setagent_] = React.useState("none");
  const [ownershiptype, setownershiptype] = React.useState("none");
  const [cultivatingmethod, setcultivatingmethod] = React.useState("none");
  const [croptype, setcroptype] = React.useState("none");
  const [seed, setseed] = React.useState("none");
  const [fertilizer, setfertilizer] = React.useState("none");
  const [water, setwater] = React.useState("none");
  const [inputlist, setinputlist] = React.useState("none");
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  const admin = useSelector((state) => state.admin);
  const farmer_ = useSelector((state) => state.farmer);
  const product = useSelector((state) => state.product);
  const staff = useSelector((state) => state.staff);
  const sales = useSelector((state) => state.sales);
  const agent = useSelector((state) => state.hauler);
  const warehouse = useSelector((state) => state.warehouse);
  const service = useSelector((state) => state.service);
  const center = useSelector((state) => state.center);
  const commodity = useSelector((state) => state.commodity);

  const Food = [
    { value: "Cereals" },
    { value: "Industrial crops" },
    { value: "Legumes" },
    { value: "Fruits" },
    { value: "Vegetables" },
    { value: "Starchy" },
    { value: "tuber" },
    { value: "root crops" }
  ];

  const fertilizers = [
    "Insecticides",
    "Herbicides",
    "Fungicides",
    "Rodenticides",
    "Nematicides",
    "Acaricides",
    "Macronutrient Fertilizers",
    "Micronutrient Fertilizers",
    "Organic Fertilizers",
    "Slow-Release Fertilizers",
    "Liquid Fertilizers",
    "Inorganic (Chemical) Fertilizers",
    "Specialty Fertilizers",
  ];

  const names = CROP_PRODUCT_OPTIONS_WITH_RICE;

  const clearForm = () => {
    setfarmer("none");
    setagent_("none");
    setinputlist("none");
    document.getElementById("farmername").value = "";
    document.getElementById("quantity").value = "";
    document.getElementById("unit").value = "";
    document.getElementById("paymentterms").value = "";
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const addfarmer = () => {
    setloading(true);
    const doer = async () => {
      try {
        const res = await axios.post("https://server.agrotraciserp.com/api/requisition/addrequisition/", {
          farmername: document.getElementById("farmername").value,
          farmer,
          agent: agent_,
          inputlist,
          quantity: document.getElementById("quantity").value,
          unit: document.getElementById("unit").value,
          paymentterms: document.getElementById("paymentterms").value,
        });
        if (res.status === 200) {
          setloading(false);
          dispatch(getrequisition({ data: res.data } ));
          setSnackbarMessage('Input request added successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage('Failed to add input request.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage('An error occurred while adding input request.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };
    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Request Input
      </Button>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Request New Input
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="farmername"
              label="Farmer Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Farmer"
              value={farmer}
              onChange={(e) => setfarmer(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option key="none" value="none">Choose Farmer</option>
              {farmer_.map((list) => (
                <option key={list._id} value={list.farmername}>{list.farmername}</option>
              ))}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Choose Agent"
              value={agent_}
              onChange={(e) => setagent_(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option key="none" value="none">Choose Agent</option>
              {staff.map((list) => (
                <option key={list._idnumber} value={list._idnumber}>{`${list.firstname} ${list.othername || ''} ${list.lastname}`}</option>
              ))}
            </TextField>
            <TextField
              id="outlined-select-currency-native"
              select
              label="Input Requested"
              value={inputlist}
              onChange={(e) => setinputlist(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option key="none" value="none">Choose</option>
              {service.map((list) => (
                <option key={list.servicename} value={list.servicename}>{list.servicename}</option>
              ))}
            </TextField>
            <TextField
              id="quantity"
              label="Quantity"
              type="number"
              autoComplete="current-text"
            />
            <TextField
              id="unit"
              label="Unit"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="paymentterms"
              label="Payment Terms"
              type="text"
              autoComplete="current-text"
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EngineeringIcon />} size="large" onClick={addfarmer}>
                Submit New Request
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}